module.exports = __webpack_public_path__ + "static/main6-en-5b59228d3ecf2414831fbd071e13f387.png";